import { patchRequest } from '@/core';
import { savedTripSearches } from '@/requests';

export default async function updateSavedTripSearchesRequest(id, patch) {
	let url = savedTripSearches.getByIdPath(id);
	let response = await patchRequest(url, {}, patch);
	return response;
}